import { ServerResponseMessagesType } from '../types/ApiResponse';
import { ServerResponse } from './ApiResponse';

export const CardCreationResponseMessages: ServerResponseMessagesType = {
    [ServerResponse.notSupported]: 'We couldn’t process your request, please try again.',
    [ServerResponse.success]: '',
    [ServerResponse.badRequest]: 'Please enter a valid EBT Card Number.',
    [ServerResponse.internalServerError]: 'We were unable to add your EBT Card. Please try again.',
};
